// Mock data for Meeta Jain - The Divine7777 Tarot Reading Services

export const services = [
  {
    id: 1,
    title: '30 Minute Reading Session',
    duration: '30 minutes',
    price: 3000,
    currency: '₹',
    description: 'A focused tarot reading session to gain clarity on specific questions about love, career, relationships, or life decisions.',
    features: [
      'One-on-one personalized reading',
      'Tarot, Angel & Oracle cards',
      'Detailed interpretation',
      'Recording provided'
    ],
    availability: 'Available'
  },
  {
    id: 2,
    title: '7 Day WhatsApp Guidance',
    duration: '7 days',
    price: 2500,
    discountedPrice: 1500,
    currency: '₹',
    description: 'Continuous spiritual support and daily card readings via WhatsApp for one week. Perfect for navigating challenging times.',
    features: [
      'Daily card readings',
      'Unlimited questions',
      'WhatsApp chat support',
      'Emotional guidance'
    ],
    availability: 'Slots open periodically',
    popular: true
  },
  {
    id: 3,
    title: '21 Days Guidance Program',
    duration: '21 days',
    price: 8000,
    currency: '₹',
    description: 'Comprehensive spiritual guidance program with daily readings, affirmations, and personalized support for transformation.',
    features: [
      'Daily personalized readings',
      'Weekly detailed analysis',
      'Healing recommendations',
      'Full spiritual support'
    ],
    availability: 'Available'
  },
  {
    id: 4,
    title: 'Healing Session',
    duration: 'Per session',
    price: 2000,
    currency: '₹',
    description: 'Energy healing sessions to remove blockages, restore balance, and promote emotional and spiritual wellbeing.',
    features: [
      'Energy clearing',
      'Chakra balancing',
      'Emotional healing',
      'Spiritual guidance'
    ],
    availability: 'Available'
  },
  {
    id: 5,
    title: 'Event Bookings',
    duration: 'Custom',
    price: null,
    currency: '₹',
    description: 'Book tarot reading sessions for your events, parties, corporate gatherings, or special occasions.',
    features: [
      'On-site readings',
      'Group sessions',
      'Customized packages',
      'Flexible scheduling'
    ],
    availability: 'Contact for pricing'
  }
];

export const crystalProducts = [
  {
    id: 1,
    name: 'Rose Quartz Crystal',
    category: 'Love & Relationships',
    description: 'Stone of unconditional love and infinite peace. Promotes self-love, deep inner healing, and attracts loving relationships.',
    image: 'https://images.unsplash.com/photo-1585838115002-cc94bb599c43?w=500',
    benefits: ['Attracts love', 'Emotional healing', 'Self-acceptance']
  },
  {
    id: 2,
    name: 'Amethyst Cluster',
    category: 'Spiritual Growth',
    description: 'Powerful protective stone with high spiritual vibration. Enhances intuition, spiritual awareness, and inner peace.',
    image: 'https://images.unsplash.com/photo-1596461593986-0e43a54d2e3e?w=500',
    benefits: ['Spiritual protection', 'Intuition boost', 'Stress relief']
  },
  {
    id: 3,
    name: 'Citrine Crystal',
    category: 'Abundance & Success',
    description: 'Stone of abundance and manifestation. Attracts wealth, prosperity, success, and positive energy.',
    image: 'https://images.unsplash.com/photo-1582655299221-2f9a91f7f498?w=500',
    benefits: ['Attracts wealth', 'Boosts confidence', 'Manifests goals']
  },
  {
    id: 4,
    name: 'Black Tourmaline',
    category: 'Protection',
    description: 'Ultimate protection stone. Shields against negative energies, electromagnetic stress, and psychic attacks.',
    image: 'https://images.unsplash.com/photo-1576697170445-f9a828c8f296?w=500',
    benefits: ['Energy protection', 'Grounding', 'EMF shield']
  },
  {
    id: 5,
    name: 'Clear Quartz Point',
    category: 'Healing & Clarity',
    description: 'Master healer and energy amplifier. Enhances clarity of thought, manifestation power, and spiritual growth.',
    image: 'https://images.unsplash.com/photo-1584997781819-6f0d81553aaa?w=500',
    benefits: ['Amplifies energy', 'Mental clarity', 'Spiritual growth']
  },
  {
    id: 6,
    name: 'Selenite Wand',
    category: 'Cleansing',
    description: 'High vibration cleansing stone. Purifies energy, clears blockages, and creates peaceful atmosphere.',
    image: 'https://images.unsplash.com/photo-1617791160588-241658c0f566?w=500',
    benefits: ['Energy cleansing', 'Mental clarity', 'Peace']
  }
];

export const blogPosts = [
  {
    id: 1,
    title: 'Understanding Tarot: A Beginner\'s Guide',
    excerpt: 'Discover the ancient art of tarot reading and how it can provide guidance and clarity in your life journey.',
    category: 'Tarot Basics',
    date: '2024-03-15',
    image: 'https://images.unsplash.com/photo-1551269901-5c5e14c25df7?w=800',
    readTime: '5 min read',
    content: `Tarot reading is an ancient practice that has been used for centuries to gain insight, clarity, and guidance in life. Whether you're new to tarot or just curious about how it works, this beginner's guide will help you understand the basics.

## What is Tarot?

Tarot is a deck of 78 cards, each carrying its own unique symbolism, story, and meaning. The deck is divided into two main parts: the Major Arcana (22 cards) representing major life events and spiritual lessons, and the Minor Arcana (56 cards) reflecting day-to-day situations and emotions.

## How Does a Tarot Reading Work?

A tarot reading is a meditative process where the reader shuffles the cards while focusing on your question or situation. The cards drawn provide insights, possibilities, and guidance. They don't predict a fixed future but rather illuminate energies and patterns at play in your life.

## Common Misconceptions

Many people believe tarot is about fortune-telling or fate. In reality, tarot is a tool for self-reflection and empowerment. The cards offer guidance, but you always have the free will to make your own choices.

## Getting Started

If you're interested in tarot, start by working with a professional reader who can guide you through the process with compassion and clarity. Each reading is a sacred space for exploration and growth.

Book your first reading with The Divine7777 today and experience the transformative power of tarot for yourself.`
  },
  {
    id: 2,
    title: 'The Power of Angel Cards in Daily Guidance',
    excerpt: 'Learn how angel cards can connect you with divine guidance and help you navigate life\'s challenges with grace.',
    category: 'Angel Cards',
    date: '2024-03-10',
    image: 'https://images.unsplash.com/photo-1518398046578-8cca57782e17?w=800',
    readTime: '4 min read',
    content: `Angel cards are a beautiful and gentle way to connect with divine guidance and angelic energies. Unlike traditional tarot, angel cards offer messages of love, hope, and encouragement directly from the angelic realm.

## What Are Angel Cards?

Angel cards are oracle decks designed to deliver messages from your guardian angels and spirit guides. Each card features beautiful imagery and uplifting messages that resonate with your current situation.

## How Angel Cards Differ from Tarot

While tarot can sometimes deliver challenging messages, angel cards are always gentle and supportive. They focus on the loving guidance available to you in every moment.

## Using Angel Cards Daily

Drawing a card each morning can set a beautiful tone for your day. The message you receive often reflects exactly what your soul needs to hear.

## When to Seek Angel Card Guidance

- During times of emotional difficulty
- When you need reassurance
- For daily spiritual practice
- To connect with deceased loved ones
- For relationship clarity

Connect with me for an angel card reading and receive divine messages tailored specifically for your journey.`
  },
  {
    id: 3,
    title: 'Crystals for Love and Relationships',
    excerpt: 'Explore the healing properties of crystals that can enhance love, improve relationships, and attract soulmate connections.',
    category: 'Crystal Healing',
    date: '2024-03-05',
    image: 'https://images.unsplash.com/photo-1584997781819-6f0d81553aaa?w=800',
    readTime: '6 min read',
    content: `Crystals have been used throughout history to attract love, heal relationships, and create harmonious connections. Each crystal carries unique vibrations that can support your journey in matters of the heart.

## Top Crystals for Love

**Rose Quartz** - The ultimate stone of unconditional love, self-love, and attracting romantic partnerships.

**Rhodonite** - Helps heal emotional wounds and supports forgiveness in relationships.

**Green Aventurine** - Opens the heart chakra and attracts new opportunities for love.

**Moonstone** - Enhances emotional sensitivity and intuition in relationships.

## How to Use Love Crystals

1. **Wear them as jewelry** to keep their energy close to your heart chakra
2. **Place under your pillow** for love-themed dreams
3. **Hold during meditation** while visualizing your ideal relationship
4. **Carry in your pocket** as a reminder of self-love
5. **Place in your bedroom** to enhance the loving energy of your space

## Setting Intentions with Crystals

Before using any crystal, cleanse it under running water or moonlight, then hold it while setting a clear intention. The clearer your intention, the more powerfully the crystal can support you.

Visit our Crystal Collection page to explore beautiful crystals for love and relationships.`
  },
  {
    id: 4,
    title: 'Full Moon Rituals for Manifestation',
    excerpt: 'Harness the powerful energy of the full moon to manifest your desires and release what no longer serves you.',
    category: 'Spiritual Practice',
    date: '2024-02-28',
    image: 'https://images.unsplash.com/photo-1532693322450-2cb5c511067d?w=800',
    readTime: '7 min read',
    content: `The full moon is a powerful time for releasing what no longer serves you and manifesting your deepest desires. Its energy amplifies intentions and brings clarity to your spiritual practice.

## Why Full Moon?

The full moon represents culmination and completion. It's the perfect time to release old patterns, beliefs, and energies that are holding you back from your highest potential.

## Simple Full Moon Ritual

### Materials Needed:
- A white candle
- Paper and pen
- A small bowl of water
- Crystals (selenite or clear quartz work well)

### Steps:

1. **Cleanse your space** with sage or incense
2. **Light the candle** and set your sacred intention
3. **Write down what you want to release** on paper
4. **Burn the paper safely** while releasing the energy
5. **Write your manifestations** for the coming weeks
6. **Place crystals in moonlight** to charge them
7. **Express gratitude** for the moon's energy

## Best Practices

- Perform rituals outdoors when possible
- Trust your intuition during the process
- Don't force outcomes - allow magic to unfold
- Keep your manifestations realistic and aligned with your higher good

## Following Up

The new moon (two weeks after the full moon) is the perfect time to plant new seeds and set fresh intentions. Together, these lunar cycles create a powerful rhythm for spiritual growth.

For personalized guidance on aligning with lunar energies, book a session with me today.`
  }
];

export const videos = [
  {
    id: 1,
    youtubeId: '4ZTvfHTSPcQ',
    title: 'The Divine7777 Timeless Reading (Business)',
    description: 'A timeless tarot reading focused on business and career insights to help you make informed decisions.',
    thumbnail: 'https://img.youtube.com/vi/4ZTvfHTSPcQ/hqdefault.jpg',
    duration: '9:23',
    category: 'Business Reading',
    date: '2019-01-01',
    type: 'video'
  },
  {
    id: 2,
    youtubeId: 'cwcmvsYZF8o',
    title: 'Tarot for All - Love Readings Timeless',
    description: 'A timeless love tarot reading to help you understand your romantic journey and relationship dynamics.',
    thumbnail: 'https://img.youtube.com/vi/cwcmvsYZF8o/hqdefault.jpg',
    duration: '10:14',
    category: 'Love Reading',
    date: '2020-05-07',
    type: 'video'
  },
  {
    id: 3,
    youtubeId: 'nKQCYRBP37E',
    title: 'The Divine - Tarot Guidance',
    description: 'Deep spiritual guidance through the divine wisdom of tarot cards for clarity in life decisions.',
    thumbnail: 'https://img.youtube.com/vi/nKQCYRBP37E/hqdefault.jpg',
    duration: '11:10',
    category: 'Spiritual Guidance',
    date: '2019-06-01',
    type: 'video'
  },
  {
    id: 4,
    youtubeId: 'ZMyOOZYH_pI',
    title: 'Tarot Aries Love Reading - March',
    description: 'Detailed Aries love reading exploring romantic prospects and emotional connections.',
    thumbnail: 'https://img.youtube.com/vi/ZMyOOZYH_pI/hqdefault.jpg',
    duration: '13:17',
    category: 'Zodiac Reading',
    date: '2018-03-15',
    type: 'video'
  },
  {
    id: 5,
    youtubeId: 'ULDXbjajUHU',
    title: 'Timeless Tarot Part 2',
    description: 'Continuation of the timeless tarot series with deeper insights and spiritual messages.',
    thumbnail: 'https://img.youtube.com/vi/ULDXbjajUHU/hqdefault.jpg',
    duration: '3:17',
    category: 'Timeless Tarot',
    date: '2019-03-01',
    type: 'video'
  },
  {
    id: 6,
    youtubeId: 'rCUa99sWa6k',
    title: 'Introduction - The Divine7777',
    description: 'Welcome to The Divine7777 - an introduction to my spiritual practice and tarot readings.',
    thumbnail: 'https://img.youtube.com/vi/rCUa99sWa6k/hqdefault.jpg',
    duration: '1:11',
    category: 'Introduction',
    date: '2018-01-01',
    type: 'video'
  },
  {
    id: 7,
    youtubeId: 'fRsv9Cp7p3k',
    title: 'The Navratri Files 2025 - Energy Reading',
    description: 'Special Navratri energy reading exploring divine feminine energies and spiritual guidance.',
    thumbnail: 'https://img.youtube.com/vi/fRsv9Cp7p3k/hqdefault.jpg',
    duration: 'Short',
    category: 'Navratri Files',
    date: '2025-10-01',
    type: 'short'
  },
  {
    id: 8,
    youtubeId: '021o5hYGjgU',
    title: 'The Navratri Files 2025 - Tarot Reading',
    description: 'Sacred Navratri tarot reading with divine guidance and spiritual insights for transformation.',
    thumbnail: 'https://img.youtube.com/vi/021o5hYGjgU/hqdefault.jpg',
    duration: 'Short',
    category: 'Navratri Files',
    date: '2025-10-05',
    type: 'short'
  },
  {
    id: 9,
    youtubeId: 'wyCFvEmvEb0',
    title: 'The Navratri Files Day 3',
    description: 'Day 3 of the Navratri tarot series with energy readings and divine messages.',
    thumbnail: 'https://img.youtube.com/vi/wyCFvEmvEb0/hqdefault.jpg',
    duration: 'Short',
    category: 'Navratri Files',
    date: '2025-10-03',
    type: 'short'
  },
  {
    id: 10,
    youtubeId: 'qVqeyqdVwJI',
    title: 'Navratri Files - Divine Guidance',
    description: 'Divine guidance and energy readings during the auspicious Navratri period.',
    thumbnail: 'https://img.youtube.com/vi/qVqeyqdVwJI/hqdefault.jpg',
    duration: 'Short',
    category: 'Navratri Files',
    date: '2025-10-02',
    type: 'short'
  },
  {
    id: 11,
    youtubeId: 'w2rtZwRy7eg',
    title: 'The Navratri Files 2025 - Shakti Energy',
    description: 'Tapping into Shakti energy with special Navratri vibes and spiritual guidance readings.',
    thumbnail: 'https://img.youtube.com/vi/w2rtZwRy7eg/hqdefault.jpg',
    duration: 'Short',
    category: 'Navratri Files',
    date: '2025-10-04',
    type: 'short'
  },
  {
    id: 12,
    youtubeId: 't4DQs3GbPbI',
    title: 'Echoes of History - Spiritual Deep Dive',
    description: 'Mystical exploration of history, hidden truths, and spiritual revelations.',
    thumbnail: 'https://img.youtube.com/vi/t4DQs3GbPbI/hqdefault.jpg',
    duration: 'Short',
    category: 'Spiritual Insights',
    date: '2025-09-01',
    type: 'short'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Priya S.',
    location: 'Mumbai',
    text: 'Meeta\'s reading was incredibly accurate and insightful. She helped me gain clarity during a difficult career transition. Highly recommended!',
    rating: 5
  },
  {
    id: 2,
    name: 'Rahul M.',
    location: 'Delhi',
    text: 'The 21-day guidance program was transformative. Meeta\'s daily readings and support helped me navigate through a challenging relationship phase.',
    rating: 5
  },
  {
    id: 3,
    name: 'Ananya K.',
    location: 'Bangalore',
    text: 'Amazing experience! The crystals I purchased have brought such positive energy to my home. Meeta\'s guidance on using them was very helpful.',
    rating: 5
  },
  {
    id: 4,
    name: 'Sanjay P.',
    location: 'Kolkata',
    text: 'Professional, compassionate, and accurate. Meeta\'s healing session helped me release emotional blockages I didn\'t even know I had.',
    rating: 5
  }
];

export const aboutInfo = {
  name: 'Meeta Jain',
  title: 'Professional Tarot, Angel & Oracle Card Reader',
  aka: 'The Divine7777',
  location: 'Kolkata, West Bengal, India',
  phone: '9681424041',
  youtube: 'https://www.youtube.com/@thedivine7777',
  googleReviews: 'https://share.google/SbynsuBln45TTEfL5',
  bio: `I am Meeta Jain, also known as "The Divine7777" on social media, a passionate and experienced tarot practitioner based in Kolkata. With years of spiritual practice and intuitive development, I help people gain clarity, direction, and confidence during uncertain phases of life.

I specialize in tarot, angel cards, and oracle card readings focused on love, career, relationships, emotional clarity, and life guidance. My approach combines ancient wisdom with compassionate understanding to provide insights that empower you to make informed decisions and navigate life's challenges with grace.

Whether you're seeking answers about relationships, career paths, personal growth, or spiritual development, I'm here to guide you with honesty, empathy, and spiritual insight.`,
  specializations: [
    'Tarot Card Reading',
    'Angel Card Guidance',
    'Oracle Card Readings',
    'Love & Relationship Guidance',
    'Career Direction',
    'Emotional Healing',
    'Life Path Clarity',
    'Crystal Healing'
  ]
};
